<template>
  <b-form-group
    label="Hatırlatma Notu"
    label-for="content"
  >
    <validation-provider
      #default="{ errors }"
      name="Hatırlatma Notu"
      rules="required"
    >
      <b-form-textarea
        id="content"
        v-model="dataItem.reminder.content"
        placeholder="Hatırlatma Notu"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'ReminderContent',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['interviews/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
